import React from "react";
import { useState } from "react";
import { useRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import Iconify from "../../../components/Iconify";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FrmEditarPersona from "./Forms/FrmEditarPersona";
const MenuPersonas = ({
  setOpenDialog,
  setBodyDialog,
  setOpenSnackBar,
  setErrorGraph,
  id,
}) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenDialog = () => {
    setBodyDialog(
      <FrmEditarPersona
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
      />
    );
    setOpenDialog(true);
  };
  console.log(id);
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={() => handleOpenDialog()}>
          <ListItemIcon>
            <Iconify icon="carbon:pen" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Modificar datos"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <Iconify icon="carbon:table-of-contents" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Desactivar"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuPersonas;
